import Rellax from 'rellax'
export default class parallaxComponent {
    static parallax
    constructor() {
        // If we're on eco-mode, cancel
        if ($('body').hasClass('eco-mode-active')) {
            return
        }

        parallaxComponent.breakpointManager()

        window.addEventListener('resize', parallaxComponent.breakpointManager)
    }

    static breakpointManager() {
        if (window.innerWidth > 1000) {
            if (!parallaxComponent.parallax) {
                parallaxComponent.parallax = new Rellax('.rellax')
            }
        } else if (parallaxComponent.parallax) {
            parallaxComponent.parallax.destroy()
            parallaxComponent.parallax = null
        }
    }
}
